const en_facility_list = {
    "": "Request List",
    detail: "Request Details",

    label: {
        booking_number: "Request No.",
        search: "Facility Name / Request No.",
        purpose: "Borrowing Purpose"
    },

    message: {
        approve_title: "Approve Request",
        approve_text: "Are you sure you want to approve this request?",
        cancel_title: "Cancel Request",
        cancel_text: "Enter the reason for canceling the request.",
    },

    error: {
        approve: "Failed to approve request",
        cancel: "Failed to cancel request",
    },

    success: {
        approve: "Request approved successfully",
        cancel: "Request canceled successfully",
    },
}

export default en_facility_list;